import { API_BASE_URL } from '../Utils/constants';
import { authFetch } from './authFetch';

// El Bearer (renovado, sin `Bearer null`, reintento ante 401) lo pone `authFetch`.
const getHeaders = () => ({
  'Content-Type': 'application/json',
});

/** @param {AbortSignal} [signal] */
export const getFavorites = async (signal) => {
  const response = await authFetch(`${API_BASE_URL}/getfavorites`, {
    headers: getHeaders(),
    signal,
  });
  return response.json();
};

export const addFavorite = async (lotId) => {
  const response = await authFetch(`${API_BASE_URL}/addfavorite?lot_id=${lotId}`, {
    method: 'POST',
    headers: getHeaders(),
  });
  return response.json();
};

export const removeFavorite = async (lotId) => {
  const response = await authFetch(`${API_BASE_URL}/removefavorite?lot_id=${lotId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};
